import { ColumnType } from "../types"
import { h } from "preact"

type TRowProps = Pick<ColumnType, "label" | "title" | "thClassName">

export default function TRow({ label, title, thClassName }: TRowProps) {
   return (
      <th title={title} className={thClassName}>
         {label}
      </th>
   )
}
